//import React from 'react'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import Graybg from '../../UI/Graybg';
import classes from './PublishPaper.module.css'
import Card from '../../UI/Card/Card';
import SecBTN from '../../UI/SecBTN';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import userService from '../../app/services/user.service';
import BtnWrapper from '../../UI/BtnWrapper';
import Loader from '../../UI/loader/loader';
import SmallLoader from '../../UI/SmallLoader/SmallLoader';
import { isEmpty } from '../../utils/custom_funtions';
import Input from '../../UI/Input/Input';
import { subDays } from 'date-fns';
import DatePick from "../../Components/DatePicker/DatePicker";


const PublishPaper = () => {
  const uid = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const [isPending, setISPending] = useState(true);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [dataAvaiblity1,setDataAvaiblity1] = useState(true)
  const [pendingData,setPendingData] = useState([]);
  const [pendingPages,setpendingPages] = useState(1)
  const [dataAvaiblity,setDataAvaiblity] = useState(true)
  const [completedData,setCompletedData] = useState([]);
  const [completedPages,setCompletedPages] = useState(1)
  const [searchParam, setSearchParam] = useState('');
  const [dateRange, setDateRange] = useState('');
  // const [startDate, endDate] = dateRange;
  const getPublishedList = async() => {
    setLoading(true)
    setCompletedPages((prev => prev + 1))
    await userService.getPublishPaperList(searchParam,dateRange ? dateRange.toLocaleDateString("sv-SE") : "",completedPages)
    .then((data) => {
      const datas  = Object.values(data.data.data)
      if(datas.length < 10){
        setDataAvaiblity(false)
      }
      const newArr = datas.map(data => {
        let result = Object.values(data.faculty).reduce(function(accObj, currentObj) {
          accObj[currentObj.sub_name] = accObj[currentObj.sub_name] || [];
          accObj[currentObj.sub_name].push(currentObj);
          return accObj;
        }, {});
        return {...data,faculty:result}
      })
      setCompletedData(newArr);
      setLoading(false)
    })
    .catch((error) => {
      setLoading(false)
        console.log(error);
      });
  }
  useEffect(() => {
    const getAlldata = async() => {
      setLoading(true)
      try {
       await userService.getPublishPaperList(searchParam,dateRange ? dateRange.toLocaleDateString("sv-SE") : "",completedPages)
      .then((data) => {
        const datas  = Object.values(data.data.data)
        if(datas.length < 10){
          setDataAvaiblity(false)
        }
        const newArr = datas.map(data => {
          let result = Object.values(data.faculty).reduce(function(accObj, currentObj) {
            accObj[currentObj.sub_name] = accObj[currentObj.sub_name] || [];
            accObj[currentObj.sub_name].push(currentObj);
            return accObj;
          }, {});
          return {...data,faculty:result}
        })
        setCompletedData(newArr);
      })
      .catch((error) => {
        // setLoading(false);
        console.log(error);
      });
  
      await userService.getPendingPublishList(uid,pendingPages)
      .then((data) => {
        const datas  = Object.values(data.data.data)
        if(datas.length < 10){
          setDataAvaiblity1(false)
        }
        const newArr = datas.map(data => {
          let result = Object.values(data.faculty).reduce(function(accObj, currentObj) {
            accObj[currentObj.sub_name] = accObj[currentObj.sub_name] || [];
            accObj[currentObj.sub_name].push(currentObj);
            return accObj;
          }, {});
          return {...data,faculty:result}
        })
        setPendingData(newArr);
        // console.log("getPendingPublishList",Object.values(newArr[0].faculty))
        // let result = Object.values(data.data.data[0].faculty).reduce(function(accObj, currentObj) {
        //   accObj[currentObj.sub_name] = accObj[currentObj.sub_name] || [];
        //   accObj[currentObj.sub_name].push(currentObj);
        //   return accObj;
        // }, {});
        // console.log("result",result)
      })
      .catch((error) => {
        // setLoading(false);
        console.log(error);
      });
        
      } catch (error) {
         setLoading(false)
         console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getAlldata()
  }, []);

  
  const pendingHandler = () => {
    setISPending(click => !click);
  }
  const CompleteHandler = () => {
    setISPending(click => !click);
  }
  const loadMoreHandler = () => {
    setBtnLoading(true)
    setCompletedPages((prev => prev + 1))
    console.log("completedPages",completedPages)
    userService
      .getPublishPaperList(searchParam,dateRange ? dateRange.toLocaleDateString("sv-SE") : "",completedPages+1)
      .then(data => {
        const datas = Object.values(data.data.data)
        if(datas.length < 10){
          setDataAvaiblity(false)
        }
        const newArr = datas.map(data => {
          let result = Object.values(data.faculty).reduce(function(accObj, currentObj) {
            accObj[currentObj.sub_name] = accObj[currentObj.sub_name] || [];
            accObj[currentObj.sub_name].push(currentObj);
            return accObj;
          }, {});
          return {...data,faculty:result}
        })
        setCompletedData((prev) => {
          return [...prev, ...newArr];
        });
      })
      .then(() => {
      setBtnLoading(false)
      })
      .catch((error) => {
        setBtnLoading(false);
        console.log("error",error);
      });
  }
  const loadMoreHandler1 = () => {
    setBtnLoading(true)
    setpendingPages((prev => prev + 1))
    userService
      .getPendingPublishList(uid,pendingPages+1)
      .then(data => {
        const datas = Object.values(data.data.data)
        if(datas.length <10){
          setDataAvaiblity1(false)
        }
        const newArr = datas.map(data => {
          let result = Object.values(data.faculty).reduce(function(accObj, currentObj) {
            accObj[currentObj.sub_name] = accObj[currentObj.sub_name] || [];
            accObj[currentObj.sub_name].push(currentObj);
            return accObj;
          }, {});
          return {...data,faculty:result}
        })
        setPendingData(prev => {
          return [...prev,...newArr]
        });
      })
      .then(() => {
      setBtnLoading(false)
      })
      .catch((error) => {
        setBtnLoading(false);
        console.log("error",error);
      });
  }
  return (
    <div className="section">
      <button onClick={()=> {
        setDateRange("")
        console.log(dateRange)
        console.log(dateRange && dateRange.toLocaleDateString("sv-SE"))
        console.log(isEmpty(dateRange))
        console.log(dateRange ? dateRange.toLocaleDateString("sv-SE") : "")
      }}>log</button>
      {loading && <Loader />}
      <h4>Publish Paper</h4>
      <Breadcrumb>
        {/*<Breadcrumb.Item><Link to='/'> Home </Link></Breadcrumb.Item>*/}
        <Breadcrumb.Item active>Publish Paper List</Breadcrumb.Item>
        <Breadcrumb.Item active>
          {isPending ? "Pending" : "Published"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
        <BtnWrapper className={classes["btn-sec"]}>
          <SecBTN
            className={isPending ? "active" : ""}
            onClick={pendingHandler}
            type="button"
          >
            Pending
          </SecBTN>
          <SecBTN
            className={isPending ? "" : "active"}
            onClick={CompleteHandler}
            type="button"
          >
            Published 
          </SecBTN>
        </BtnWrapper>
        {isPending ? (
          <>
            {isEmpty(pendingData) && !loading ? (
              <p className="text-center">No data available.</p>
            ) : (
              <>
                {/* <Row className="mb-3 align-items-end">
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label htmlFor="Paper_title">Paper Name</Form.Label>
                    <Input
                      required
                      style={{ background: "#fff" }}
                      type="text"
                      placeholder="Enter Paper Name"
                      // value={reqData.paper_name}
                      onChange={(e) => {}}
                    />
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label htmlFor="Paper_title">
                      Select Date Range
                    </Form.Label>
                    <DatePicker
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                        console.log(update);
                      }}
                      style={{ backgroundColor: "#fff" }}
                      isClearable={true}
                      placeholder="Enter date range..."
                    />
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <SecBTN className="sec-btn1">Search</SecBTN>
                  </Col>
                </Row> */}

                {pendingData.map((data, i) => {
                  return (
                    <>
                      <Card key={data.paper_id}>
                        <Row>
                          <Col md={11} sm={12}>
                            <h5 className={classes.title}>
                              {data.paper_name}{" "}
                              <span>(Status : {data.status_name})</span>
                            </h5>
                            <div className={classes["publish-details"]}>
                              <span>
                                Session : <b>{data.SESSION}</b>
                              </span>
                              <span>
                                Center : <b>{data.center}</b>
                              </span>
                              <span>
                                Class : <b>{data.class}</b>
                              </span>
                              <span>
                                Target : <b>{data.target}</b>
                              </span>
                              <span>
                                Format : <b>{data.paper_format}</b>
                              </span>
                            </div>
                            <div className={classes["publish-details"]}>
                              <span>
                                Phase : <b>{data.phase}</b>
                              </span>
                              <span>
                                Status : <b>{data.status_name}</b>
                              </span>
                              <span>
                                Exam On : <b>{data.to_be_held_on}</b>
                              </span>
                              <span>
                                Last Date of submission :{" "}
                                <b>{data.to_be_completed_by}</b>
                              </span>
                              <span>
                                Date Of Finalization :{" "}
                                <b>{data.to_be_final_by}</b>
                              </span>
                            </div>
                            <div className={classes["publish-details"]}>
                              <span>
                                Paper Requested By : <b>{data.creator}</b>
                              </span>
                              <span>
                                Paper Requested On : <b>{data.created_on}</b>
                              </span>
                              {data.batch_name && (
                                <span>
                                  Batch : <b>{data.batch_name}</b>
                                </span>
                              )}
                            </div>
                            <div className={classes["publish-details"]}>
                              <span>
                                Created By :
                                {/* <b>Chandran - Physics(Section A : Completed)</b> */}
                              </span>
                              <div>
                                <table className={`${classes.creator}`}>
                                  <tbody>
                                    {Object.keys(data.faculty).map(
                                      (faculty) => {
                                        return (
                                          <>
                                            <tr>
                                              <th
                                                style={{
                                                  verticalAlign: "baseline",
                                                }}
                                              >
                                                {faculty}
                                              </th>
                                              <td className="d-flex gap-1">
                                                <span>:</span>
                                                <ul
                                                  style={{ listStyle: "none" }}
                                                >
                                                  {data.faculty[faculty].map(
                                                    (x, i) => {
                                                      return (
                                                        <li>
                                                          {`${x.name} (${x.new_status})`}
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                                </ul>
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col
                            md={1}
                            sm={12}
                            className={`text-end text-sm-center`}
                          >
                            <Link
                              to={`/publishPaper/publishedView/${data.paper_id}?status=${data.status_name}`}
                            >
                              <SecBTN className={classes["view-btn"]}>
                                View
                              </SecBTN>
                            </Link>
                          </Col>
                        </Row>
                      </Card>
                    </>
                  );
                })}
              </>
            )}
            {dataAvaiblity1 && !isEmpty(pendingData) && (
              <div className="text-center my-4">
                <SecBTN
                  className={`${classes["view-btn"]} sec-btn1`}
                  onClick={loadMoreHandler1}
                >
                  Load more
                  {btnLoading && <SmallLoader />}
                </SecBTN>
              </div>
            )}
          </>
        ) : (
          <>
            {isEmpty(completedData) && !loading ? (
              <p className="text-center">No data available.</p>
            ) : (
              <>
              <Row className="mb-3 align-items-end">
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label htmlFor="Paper_title">Paper Name / ID</Form.Label>
                    <Input
                      required
                      style={{ background: "#fff" }}
                      type="text"
                      placeholder="Enter Paper Name or ID"
                      value={searchParam}
                      onChange={(e) => setSearchParam(e.target.value)}
                    />
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label htmlFor="Paper_title">
                      Select Date
                    </Form.Label>
                    <DatePick
                    placeholder="Select Date"
                    selected={dateRange}
                    style={{ backgroundColor: "#fff" }}
                      isClearable={true}
                    onChange={(update) => {
                      setDateRange(update);
                      console.log(update.toLocaleDateString("sv-SE"));
                    }}
                  />
                    {/* <DatePicker
                      // selectsRange={true}
                      // startDate={startDate}
                      // endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                        console.log(update.toLocaleDateString("sv-SE"));
                      }}
                      style={{ backgroundColor: "#fff" }}
                      isClearable={true}
                      placeholder="Select date..."
                    /> */}
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <SecBTN className="sec-btn1" onClick={getPublishedList}>Search</SecBTN>
                  </Col>
                </Row>
              {completedData.map((data, i) => {
                return (
                    <Card key={data.paper_id}>
                      <Row>
                        <Col md={11} sm={12}>
                          <h5 className={classes.title}>
                            {data.paper_name}{" "}
                            <span>(Status : {data.status_name})</span>
                          </h5>
                          <div className={classes["publish-details"]}>
                            <span>
                              Session : <b>{data.SESSION}</b>
                            </span>
                            <span>
                              Center : <b>{data.center}</b>
                            </span>
                            <span>
                              Class : <b>{data.class}</b>
                            </span>
                            <span>
                              Target : <b>{data.target}</b>
                            </span>
                            <span>
                              Format : <b>{data.paper_format}</b>
                            </span>
                          </div>
                          <div className={classes["publish-details"]}>
                            <span>
                              Phase : <b>{data.phase}</b>
                            </span>
                            <span>
                              Status : <b>{data.status_name}</b>
                            </span>
                            <span>
                              Exam On : <b>{data.to_be_held_on}</b>
                            </span>
                            <span>
                              Last Date submission :{" "}
                              <b>{data.to_be_completed_by}</b>
                            </span>
                            <span>
                              Date Of Finalization :{" "}
                              <b>{data.to_be_final_by}</b>
                            </span>
                          </div>
                          <div className={classes["publish-details"]}>
                            <span>
                              Paper Requested By : <b>{data.creator}</b>
                            </span>
                            <span>
                              Paper Requested On : <b>{data.created_on}</b>
                            </span>
                            {data.batch_name && (
                              <span>
                                Batch : <b>{data.batch_name}</b>
                              </span>
                            )}
                          </div>
                          <div className={classes["publish-details"]}>
                            <span>
                              Created By :
                              {/* <b>Chandran - Physics(Section A : Completed)</b> */}
                            </span>
                            <div>
                              <table className={`${classes.creator}`}>
                                <tbody>
                                  {Object.keys(data.faculty).map((faculty) => {
                                    return (
                                      <>
                                        <tr>
                                          <th
                                            style={{
                                              verticalAlign: "baseline",
                                            }}
                                          >
                                            {faculty}
                                          </th>
                                          <td className="d-flex gap-1">
                                            <span>:</span>
                                            <ul style={{ listStyle: "none" }}>
                                              {data.faculty[faculty].map(
                                                (x, i) => {
                                                  return (
                                                    <li>
                                                      {`${x.name} (${x.new_status})`}
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Col>
                        <Col md={1} sm={12} className={`text-end`}>
                          <Link
                            to={`/publishPaper/publishedView/${data.paper_id}?status=${data.status_name}`}
                          >
                            <SecBTN className={classes["view-btn"]}>
                              View
                            </SecBTN>
                          </Link>
                        </Col>
                      </Row>
                    </Card>
                );
              })}
              </>
            )}
            {dataAvaiblity && !isEmpty(completedData) && (
              <div className="text-center my-4">
                <SecBTN
                  className={`${classes["view-btn"]} sec-btn1`}
                  onClick={loadMoreHandler}
                >
                  Load more
                  {btnLoading && <SmallLoader />}
                </SecBTN>
              </div>
            )}
          </>
        )}
      </Graybg>
    </div>
  );
}

export default PublishPaper
